import { render, staticRenderFns } from "./collectiondonut.vue?vue&type=template&id=51b05f8e&"
import script from "./collectiondonut.vue?vue&type=script&lang=js&"
export * from "./collectiondonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports